/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AllGamesQuestsGameInfo } from './AllGamesQuestsGameInfo';
import {
    AllGamesQuestsGameInfoFromJSON,
    AllGamesQuestsGameInfoFromJSONTyped,
    AllGamesQuestsGameInfoToJSON,
    AllGamesQuestsGameInfoToJSONTyped,
} from './AllGamesQuestsGameInfo';

/**
 * 
 * @export
 * @interface AllGamesQuestsGameData
 */
export interface AllGamesQuestsGameData {
    /**
     * 
     * @type {AllGamesQuestsGameInfo}
     * @memberof AllGamesQuestsGameData
     */
    gameInfo?: AllGamesQuestsGameInfo;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof AllGamesQuestsGameData
     */
    quests?: Array<{ [key: string]: any; }>;
}

/**
 * Check if a given object implements the AllGamesQuestsGameData interface.
 */
export function instanceOfAllGamesQuestsGameData(value: object): value is AllGamesQuestsGameData {
    return true;
}

export function AllGamesQuestsGameDataFromJSON(json: any): AllGamesQuestsGameData {
    return AllGamesQuestsGameDataFromJSONTyped(json, false);
}

export function AllGamesQuestsGameDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllGamesQuestsGameData {
    if (json == null) {
        return json;
    }
    return {
        
        'gameInfo': json['gameInfo'] == null ? undefined : AllGamesQuestsGameInfoFromJSON(json['gameInfo']),
        'quests': json['quests'] == null ? undefined : json['quests'],
    };
}

export function AllGamesQuestsGameDataToJSON(json: any): AllGamesQuestsGameData {
    return AllGamesQuestsGameDataToJSONTyped(json, false);
}

export function AllGamesQuestsGameDataToJSONTyped(value?: AllGamesQuestsGameData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gameInfo': AllGamesQuestsGameInfoToJSON(value['gameInfo']),
        'quests': value['quests'],
    };
}

